import { render, staticRenderFns } from "./component-editor.vue?vue&type=template&id=01e3d56f"
import script from "./component-editor.vue?vue&type=script&lang=js"
export * from "./component-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports